export const checkPermission = (headers, userData, actionType = 'create') => {
  if (userData?.role === 'SUPERADMIN') {
    return true;
  }

  if (!userData?.role?.details) {
    return false;
  }

  const headerName = headers?.name?.toLowerCase();
  const roleDetails = userData.role.details;

  let permissionName = '';

  if (headerName.includes('product')) {
    permissionName = 'Products';
  } else if (headerName.includes('service')) {
    permissionName = 'Services';
  } else if (headerName.includes('inventory') && headerName.includes('transfer')) {
    permissionName = 'Inventory Transfer';
  } else if (headerName.includes('inventory') && headerName.includes('receive')) {
    permissionName = 'Inventory Receive';
  } else if (headerName.includes('inventory') && headerName.includes('request')) {
    permissionName = 'Inventory Request';
  } else if (headerName.includes('inventory')) {
    permissionName = 'Inventory';
  } else if (headerName.includes('billing') && headerName.includes('return')) {
    permissionName = 'Billing Returns';
  } else if (headerName.includes('billing')) {
    permissionName = 'Billing';
  } else if (headerName.includes('sale') && headerName.includes('return')) {
    permissionName = 'Sales Returns';
  } else if (headerName.includes('sale')) {
    permissionName = 'Sales';
  } else if (headerName.includes('credit')) {
    permissionName = 'Credit Notes';
  } else if (headerName.includes('lpo')) {
    permissionName = 'LPO';
  } else if (headerName.includes('grn')) {
    permissionName = 'GRN';
  } else if (headerName.includes('purchase') && headerName.includes('return')) {
    permissionName = 'Purchase Returns';
  } else if (headerName.includes('purchase')) {
    permissionName = 'Purchase';
  } else if (headerName.includes('debit')) {
    permissionName = 'Debit Notes';
  } else if (headerName.includes('expense')) {
    permissionName = 'Expenses';
  } else if (headerName.includes('customer') && headerName.includes('outstanding')) {
    permissionName = 'Clearing Customer Outstanding Balances';
  } else if (headerName.includes('customer')) {
    permissionName = 'Customers';
  } else if (headerName.includes('supplier')) {
    permissionName = 'Suppliers';
  } else if (headerName.includes('chart') || headerName.includes('account')) {
    permissionName = 'Chart of Accounts';
  } else if (headerName.includes('journal')) {
    permissionName = 'Journal Entries';
  } else if (headerName.includes('financial') || headerName.includes('report')) {
    permissionName = 'Financial Reports';
  } else if (headerName.includes('import') || headerName.includes('export')) {
    permissionName = 'Import-Export';
  } else if (headerName.includes('setting')) {
    permissionName = 'Settings';
  } else if (headerName.includes('dashboard')) {
    permissionName = 'Dashboard';
  }

  const permission = roleDetails.find(detail => 
    detail.name.toLowerCase() === permissionName.toLowerCase()
  );

  if (!permission) return false;

  switch (actionType) {
    case 'create':
      return permission.full_access === 1 || permission.create === 1;
    case 'update':
      return permission.full_access === 1 || permission.update === 1;
    case 'delete':
      return permission.full_access === 1 || permission.delete === 1;
    case 'view':
      return permission.full_access === 1 || permission.view === 1;
    case 'approve':
      return permission.full_access === 1 || permission.approve === 1;
    default:
      return permission.full_access === 1;
  }
};

export const checkCreatePermission = (headers, userData) => 
  checkPermission(headers, userData, 'create');

export const checkUpdatePermission = (headers, userData) => 
  checkPermission(headers, userData, 'update');

export const checkDeletePermission = (headers, userData) => 
  checkPermission(headers, userData, 'delete');

export const checkViewPermission = (headers, userData) => 
  checkPermission(headers, userData, 'view');